import { useEffect } from "react"

/**
 * While mounted, cancels the browser default for drags/drops that land outside
 * an explicit drop target — without it, a drop that misses a FileDropTarget
 * navigates the page to the dropped file. Targets still receive their drops:
 * their handlers run first, and preventDefault on window only suppresses the
 * navigation default, never the target's own handling.
 */
const usePreventWindowFileDrop = (): void => {
  useEffect(() => {
    const preventDefault = (event: Event) => event.preventDefault()

    window.addEventListener("dragover", preventDefault)
    window.addEventListener("drop", preventDefault)

    return () => {
      window.removeEventListener("dragover", preventDefault)
      window.removeEventListener("drop", preventDefault)
    }
  }, [])
}

export default usePreventWindowFileDrop
